import { render, staticRenderFns } from "./RequestsPending.vue?vue&type=template&id=644bd1e8&scoped=true&"
import script from "./RequestsPending.vue?vue&type=script&lang=js&"
export * from "./RequestsPending.vue?vue&type=script&lang=js&"
import style0 from "./RequestsPending.vue?vue&type=style&index=0&id=644bd1e8&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "644bd1e8",
  null
  
)

export default component.exports